module.exports = __webpack_public_path__ + "static/media/Tribal Woman.62cf30a1.jpg";